import MessageBox from 'components/commons/MessageBox/MessageBox';
import { FormattedText } from 'core/i18n';
import React from 'react';

export const TransferComissionAdvise = () => {
    return (
        <MessageBox
            titleText={<FormattedText value="identification-warning" />}
            contentText={<FormattedText value="identification-comissionTransferAdvise" />}
            boxColor={'yellow'}
            iconColor={'warning-2-center'}
        />
    );
};
